(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-offline", [], factory);
	else if(typeof exports === 'object')
		exports["vue-offline"] = factory();
	else
		root["vue-offline"] = factory();
})(window, function() {
return 